import React, {useState} from 'react';
import {labels, ticketNumberRegex} from '../../../util/uiconstants';
import Loader from '../../Common/Loaders/loadingindicator';
import styled from 'styled-components';
import ModalControl from '../../Common/Modal/Modal';
import {validateTicketNumber} from './util';
import MotifInput from '@ey/motif-react-wrapper/Input';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifButton from '@ey/motif-react-wrapper/Button';

const TicketInputWrapper = styled.section`
	.ticketdetail {
		.loadingstyle {
			height: calc(100vh - var(--px-780)) !important;
		}

		.modal-center {
			.message {
				padding: var(--spacing-x-large);
				min-height: var(--px-225);
			}

			.confirmationmessage {
				padding-bottom: var(--spacing-small);
			}

			.motif-form-field {
				width: var(--px-400);
				.motif-input {
					height: var(--px-44);
				}
			}

			.modal-footer {
				width: 100%;
				display: inline-flex;
				justify-content: end;
				padding: var(--spacing-x-large);
				button {
					margin-left: var(--px-12);
				}
			}
		}
	}
`;

function TicketInput(props) {
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);
	const [errorMesage, setErrorMesage] = useState(labels.validationMessage);

	const closeTicketModal = () => {
		props.onHide(false);
	};

	const onConfirmClick = () => {
		setIsSubmitClicked(true);
		if (!validateTicketNumber(ticketNumber)) {
			return;
		}

		props.onConfirmClick(ticketNumber.trim());
		props.onHide(false);
	};

	return (
		<TicketInputWrapper>
			<section className="ticketdetail">
				<section className="modal-center">
					<section className="message customScrollbar">
						<section className="confirmationmessage" aria-label="message">
							<section className="motif-body1-default-regular">
								{props.confirmationMessage
									? props.confirmationMessage
									: labels.confirmationMessage}
							</section>
						</section>
						<section>
							<section>
								<MotifFormField>
									<MotifLabel position="in">
										{labels.ticketNumberLabel}
									</MotifLabel>
									<MotifInput
										labelPosition="in"
										value={ticketNumber}
										maxLength={50}
										clearButtonTitle={labels.clear}
										onChange={(event) => {
											const ticket = event.target.value;
											const isInvalidTicket =
												ticket && !ticketNumberRegex.test(ticket);
											setErrorMesage(
												isInvalidTicket
													? labels.ticketNumberRegexLabel
													: labels.validationMessage
											);
											setTicketNumber(ticket);
										}}
									></MotifInput>
									{!validateTicketNumber(ticketNumber) && isSubmitClicked && (
										<MotifErrorMessage>{errorMesage}</MotifErrorMessage>
									)}
								</MotifFormField>
							</section>
						</section>
					</section>
					<section className="modal-footer">
						<MotifButton
							variant="ghost"
							size="medium"
							onClick={() => closeTicketModal()}
						>
							{props.cancelButtonLabel
								? props.cancelButtonLabel
								: labels.cancelButtonLabel}
						</MotifButton>
						<MotifButton
							variant="primary"
							size="medium"
							disabled={
								!ticketNumber || ticketNumber.trim().length == 0 ? true : false
							}
							onClick={() => {
								onConfirmClick();
							}}
						>
							{props.confirmButtonLabel
								? props.confirmButtonLabel
								: labels.save}
						</MotifButton>
					</section>
				</section>
			</section>
		</TicketInputWrapper>
	);
}

function TicketModal(props) {
	const [isLoading, setIsLoading] = useState(false);

	return (
		<>
			{isLoading ? (
				<Loader show view="blockView" styleName="loadingstyle" />
			) : (
				<ModalControl
					title={props.modalHeaderLabel}
					onOkClick={() => {}}
					onHide={() => props.onHide(false)}
					isOkButtonDisabled={true}
					show={true}
					modalsize="x-small"
					showButtons={false}
					closeTitle={labels.close}
					role="dialog"
					focusTrapActive={false}
					modalContainerClass={'ticket-modal'}
				>
					<TicketInput
						onHide={props.onHide}
						confirmationMessage={props.confirmationMessage}
						confirmButtonLabel={props.confirmButtonLabel}
						cancelButtonLabel={props.cancelButtonLabel}
						onConfirmClick={props.onConfirmClick}
					/>
				</ModalControl>
			)}
		</>
	);
}
export default TicketModal;
